import { type ZodErrorMap, ZodIssueCode, z } from 'zod';

/**
 * Polskie komunikaty Zod dla typowych błędów. Schematy z własnym `message` mają pierwszeństwo.
 * Wywołaj `installPolishZodErrors()` raz przy starcie aplikacji (API, worker, web).
 */
export const polishZodErrorMap: ZodErrorMap = (issue, ctx) => {
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === 'undefined' || issue.received === 'null') return { message: 'Pole jest wymagane' };
      return { message: 'Nieprawidłowy typ wartości' };
    case ZodIssueCode.too_small:
      if (issue.type === 'string') {
        return { message: issue.minimum === 1 ? 'Pole jest wymagane' : `Minimum ${issue.minimum} znaków` };
      }
      if (issue.type === 'array') return { message: `Wybierz co najmniej ${issue.minimum}` };
      return { message: `Wartość musi być ≥ ${issue.minimum}` };
    case ZodIssueCode.too_big:
      if (issue.type === 'string') return { message: `Maksimum ${issue.maximum} znaków` };
      if (issue.type === 'array') return { message: `Wybierz najwyżej ${issue.maximum}` };
      return { message: `Wartość musi być ≤ ${issue.maximum}` };
    case ZodIssueCode.invalid_string:
      if (issue.validation === 'email') return { message: 'Nieprawidłowy adres email' };
      if (issue.validation === 'uuid') return { message: 'Nieprawidłowy identyfikator' };
      if (issue.validation === 'url') return { message: 'Nieprawidłowy adres URL' };
      if (issue.validation === 'datetime') return { message: 'Nieprawidłowa data i godzina' };
      return { message: 'Nieprawidłowy format' };
    case ZodIssueCode.invalid_enum_value:
      return { message: 'Nieprawidłowa wartość' };
    case ZodIssueCode.unrecognized_keys:
      return { message: 'Nieznane pola' };
    case ZodIssueCode.invalid_date:
      return { message: 'Nieprawidłowa data' };
    default:
      return { message: ctx.defaultError };
  }
};

let installed = false;

export function installPolishZodErrors(): void {
  if (installed) return;
  z.setErrorMap(polishZodErrorMap);
  installed = true;
}
